import React from 'react';
import { Typography } from '@mui/material';
import { FieldArrayWithId, useFormContext } from 'react-hook-form';
import { Listing } from 'components/shared/TableListing/table/Listing';

import { getTradeInListingColumns } from '../../../../lib';
import { TradeInPayoffDetails } from './TradeInPayoffDetails';
import { TradeInListingActionPanelBottom } from './TradeInListingActionPanelBottom';
import { DealBuilderFormValues, TradeInListingConfig, TradeInListingItem } from '../../../../types';

interface Props {
  onAddRow: () => void;
  onFieldBlur: (rowIndex: number) => void;
  onRemoveRow: (rowIndex: number) => void;
  fields: FieldArrayWithId<DealBuilderFormValues, 'pricing.tradeIn'>[];
}

export const TradeInListing = ({ fields, onFieldBlur, onRemoveRow, onAddRow }: Props) => {
  const form = useFormContext<DealBuilderFormValues>();
  const columns = getTradeInListingColumns({ onFieldBlur, onRemoveRow });

  return (
    <Listing<TradeInListingItem, TradeInListingConfig>
      columns={columns}
      tableData={fields}
      injectContext={{
        form,
      }}
      renderRowDetail={({ rowIndex }) => (
        <TradeInPayoffDetails rowIndex={rowIndex} form={form} onFieldBlur={onFieldBlur} />
      )}
      actionPanelTop={() => (
        <Typography variant="h6" component="span">
          Trade-In
        </Typography>
      )}
      actionPanelBottom={() => <TradeInListingActionPanelBottom form={form} onAddRow={onAddRow} />}
    />
  );
};
